// Copyright (c) 2021 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {getAllRequestAsPerStatus} from '../../shared/repositories';

export const readReturnedDealersLaborRates = requestId =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const getForTcsm = false;

        const requestStatus = 'RETURNED';

        try {

            const dealerLaborRates = await getAllRequestAsPerStatus(requestStatus, getForTcsm, requestId);

            dispatch({
                data: dealerLaborRates,
                type: actions.SET_SELECTED_ACCOUNT_LABOR_RATES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/action-creators/read-returned-dealers-labor-rates.js